export enum ClaimStatus {
  'SUBMITTED' = 'SUBMITTED',
  'REJECTED' = 'REJECTED',
  'RESUBMITTED' = 'RESUBMITTED',
  'PRE_APPROVED' = 'PRE_APPROVED',
  'APPROVED' = 'APPROVED',
  'PAID' = 'PAID',
  'PROVISIONAL' = 'PROVISIONAL',
}

export enum ClaimSource {
  ON_PLATFORM = 'ON_PLATFORM',
  OFF_PLATFORM = 'OFF_PLATFORM',
}

export enum ClaimMethod {
  STAGED = 'STAGED',
  PERIODIC = 'PERIODIC',
}

export enum PropertyUsage {
  COMMERCIAL = 'COMMERCIAL',
  RESIDENTIAL = 'RESIDENTIAL',
  UNSPECIFIED = 'UNSPECIFIED',
}

export enum ReviewClaimAction {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum ClaimAction {
  CREATE = 'CREATE',
  AMEND = 'AMEND',
  REVIEW = 'REVIEW',
  EDIT = 'EDIT',
}

// Shortcut of making claims
export enum ClaimType {
  STANDARD = 'STANDARD',
  RETENTION = 'RETENTION',
}
